import { render } from "./PreChatForm.vue?vue&type=template&id=f8ec8622&scoped=true"
import script from "./PreChatForm.vue?vue&type=script&lang=js"
export * from "./PreChatForm.vue?vue&type=script&lang=js"

import "./PreChatForm.vue?vue&type=style&index=0&id=f8ec8622&scoped=true&lang=sass"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8ec8622"]])

export default __exports__